import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "toggleIcon"]

  declare readonly containerTarget: HTMLElement
  declare readonly toggleIconTarget: HTMLElement

  toggle(): void {
    if (this.containerTarget.classList.contains('hidden')) {
      this.containerTarget.classList.remove('hidden')
      this.toggleIconTarget.innerHTML = '<i class="fas fa-chevron-up"></i>'
    } else {
      this.containerTarget.classList.add('hidden')
      this.toggleIconTarget.innerHTML = '<i class="fas fa-chevron-down"></i>'
    }
  }
}
